import { FC } from 'react';
import styles from './Loader.module.css';

interface LoaderProps {
  fullscreen?: boolean;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const Loader: FC<LoaderProps> = ({ 
  fullscreen = false, 
  size = 'medium',
  className = ''
}) => {
  if (fullscreen) {
    return (
      <div className={styles.fullscreenLoader}>
        <div className={`${styles.spinner} ${styles[size]}`}></div>
      </div>
    );
  }

  return (
    <div className={`${styles.loaderContainer} ${className}`}>
      <div className={`${styles.spinner} ${styles[size]}`}></div>
    </div>
  );
};